import './index.scss';

export default () => (
  <div className='loader-body'>
    <div className='loader'>
      <div className='ball-pulse'>
        <div />
        <div />
        <div />
      </div>
    </div>
  </div>
);
